import { Link } from 'react-router-dom';
import { usePromo } from '@/lib/promoConfig';
import { useAuth } from '@/contexts/AuthContext';

/**
 * Persistent marquee promo strip. Driven by the live promo state in
 * `lib/promoConfig.js` (which itself is sourced from
 * `GET /api/site-settings/homepage-promo`). Admins toggle the active
 * promo from `/admin/coupons`. Auto-hides once the linked coupon has
 * expired, when disabled, or for authenticated viewers (members redeem
 * via the Subscription page; the marquee is a conversion tool for
 * unauthenticated traffic).
 */
export default function PromoBanner() {
  const { user } = useAuth();
  const { promo, isPromoActive } = usePromo();
  // Admin QA: `?promo_preview=1` lets logged-in admins see the marquee
  // exactly as anonymous visitors would.
  let previewing = false;
  try { previewing = new URLSearchParams(window.location.search).get('promo_preview') === '1'; }
  catch { /* ignore */ }
  if (user && !previewing) return null;
  if (!isPromoActive) return null;
  return (
    <div className="bg-[#df5681] text-white overflow-hidden" data-testid="promo-banner">
      <div className="animate-marquee whitespace-nowrap py-2 flex items-center">
        {[1, 2, 3].map(i => (
          <span key={i} className="mx-8 text-sm font-medium inline-flex items-center gap-2">
            Use code <span className="font-bold bg-white/20 px-2 py-0.5 rounded">{promo.code}</span>
            for {promo.headline} — {promo.bodySuffix}
            <Link to={promo.redeemPath} className="underline hover:no-underline">{promo.redeemLabel}</Link>
            <span className="mx-4 opacity-50">|</span>
          </span>
        ))}
      </div>
      <style>{`
        @keyframes marquee { 0% { transform: translateX(0); } 100% { transform: translateX(-33.33%); } }
        .animate-marquee { animation: marquee 20s linear infinite; display: inline-flex; width: max-content; }
      `}</style>
    </div>
  );
}
